import { uploadDocument } from 'app/model/uploadDocument';
import {
  Component, OnInit, DoCheck, Output,
  Input,
  EventEmitter,
  HostBinding,
  HostListener
} from '@angular/core';
import { CrmService } from 'app/services/crm.service';
import { ContextService } from 'app/services/context.service';
import { environment } from 'environments/environment';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { ToastService } from 'app/services/toast.service';
import { RemoteAnswer } from 'app/model/remote-answer';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {
  private readonly maxUploadBytes = 100 * 1024 * 1024;
  @Input() remoteAnswerId: string;
  @Input() readOnly: boolean;
  @Input() answer: RemoteAnswer;
  fileNames: string[];
  private lastAnswerFileNamesRef: string[];
  @Output() hasFiles = new EventEmitter<boolean>();
  @BlockUI() blockUI: NgBlockUI;

  constructor(private crmService: CrmService, private context: ContextService, private toastService: ToastService) { }

  ngOnInit(): void {
    this.syncFileNamesFromAnswer();
    //this.blockUI.start();
    // this.crmService.GetDocument(this.remoteAnswerId).subscribe(f => {
    //   this.fileNames = f;
    //   if (f.length > 0) {
    //     this.hasFiles.emit(true);
    //   }
    //   this.blockUI.stop();
    // });
  }

  ngDoCheck(): void {
    this.syncFileNamesFromAnswer();
  }

  private syncFileNamesFromAnswer() {
    const nextRef = this.answer?.fileNames;
    if (nextRef === this.lastAnswerFileNamesRef) {
      return;
    }

    this.lastAnswerFileNamesRef = nextRef;
    this.fileNames = nextRef;
    if (this.fileNames && this.fileNames.length > 0) {
      this.hasFiles.emit(true);
    }
  }

  files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(fileName: string) {
    this.blockUI.start();

    this.crmService.DeleteDocument(this.remoteAnswerId, fileName).subscribe(r => {
      this.fileNames = r;
      this.blockUI.stop();

    });
  }

  downloadFile(fileName: string) {
    var url = environment.apiurl + "documents?FileName=" + encodeURIComponent(fileName) + "&AnswerId=" + this.remoteAnswerId;
    window.open(url, "_blank");
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    this.blockUI.start();
    var subArray: string[][] = new Array();
    var counter = 0;
    //for (const item of files) {
    var myReader: FileReader = new FileReader();
    myReader.onloadend = (e) => {
      
      if (files.length>0){
      if (files[counter].name.indexOf('.heic')>0){
        this.toastService.showDanger("Unable to upload file: " + files[counter].name + " not permitted to upload files of this type");
        
        this.blockUI.stop();
        return;
      }
      if (files[counter].size <= this.maxUploadBytes) {
      this.crmService.UploadDocument(this.context.base64ArrayBuffer(myReader.result), this.remoteAnswerId, files[counter].name).subscribe(
          r=>{
            if (!r.result){
              this.toastService.showDanger(r.message);
           
            }
            else{
              subArray.push(r.fileNames)
            }
            counter++;
            if (counter < files.length) {
              myReader.readAsArrayBuffer(files[counter]);
            }
            if (counter == files.length) {
              if (subArray.length > 0) {
                forkJoin(subArray).subscribe(r => {
                  
                  this.fileNames=subArray[0];
                  this.hasFiles.emit(true);
                  this.blockUI.stop();
                })
              } else {
                this.blockUI.stop();
      
              }
            }
          });
          
       
      } else {
        this.toastService.showDanger("Unable to upload file: " + files[counter].name + " size exceed the maximum allowed size of 100MB");
      }
    }
      // .subscribe(r => {
      //   this.fileNames = r;
      // })
     
      

      
      //s this.fileString = myReader.result;
    };
     if (files.length>0){
    myReader.readAsArrayBuffer(files[counter]);
   }
   else{
    this.hasFiles.emit(true);
    this.blockUI.stop();
   }
    //item.progress = 0;
    //this.files.push(item);
    //}

    //this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
